import { render, staticRenderFns } from "./AgregarModuloModal.vue?vue&type=template&id=d5ad155c"
import script from "./AgregarModuloModal.vue?vue&type=script&lang=js"
export * from "./AgregarModuloModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports